import { NavigateFunction } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../../routes/paths";
import { ExistingAmbassadorSignupFormData } from "./config";
import { ExistingAmbassadorSignupResponseData } from "./types";

export async function handleExistingAmbassadorSignupSuccess(
  userData: ExistingAmbassadorSignupResponseData,
  navigate: NavigateFunction,
  fetchUserProfile: () => Promise<any>
): Promise<void> {
  if (userData.profileId) {
    await fetchUserProfile();
    navigate(ROUTE_PATHS.MY_PROFILE);
  } else {
    navigate(ROUTE_PATHS.AUTH.SIGNUP_MORE_ABOUT_AMBASSADOR_COMPANY);
  }
}

export function getExistingAmbassadorSignupPayload(
  data: ExistingAmbassadorSignupFormData
): {
  email: string;
  password: string;
  role: string;
} {
  return {
    email: data.email.toLowerCase(),
    password: data.password,
    role: "ambassador",
  };
}
